import { getUtcTime } from '@bingads-webui-universal/primitive-utilities';
import { constants } from '../constants';
import { Logger } from './logger';
import {
  IScenario, IActivity, TAjaxLogArgs, IAjaxLogger,
} from '../types';

/**
 * Ajax Logger - internal logger that can used by for logging Ajax calls
 */
export class AjaxLogger extends Logger implements IAjaxLogger {
  /**
   * ajax - logs passed in args as ajax logs
   */
  ajax(
    scenario: IScenario,
    activity: IActivity,
    parentScenario: IScenario,
    [
      requestId,
      api,
      isMethodEnter,
      httpMethod,
      timeTaken,
      pass,
      message,
      entityCount,
      includeRendering,
    ]: TAjaxLogArgs,
  ): void {
    super.log({
      requestId,
      api,
      isMethodEnter,
      httpMethod,
      timeTaken,
      pass,
      message,
      entityCount,
      entryType:
        includeRendering === true
          ? constants.ENTRYTYPE.AJAXRENDER
          : constants.ENTRYTYPE.AJAX,
      timeStamp: getUtcTime(),
      logLevel: constants.LOGLEVEL.INFO,
      logCategory: constants.LOGCATEGORY.PERFORMANCE,
      activity,
      scenario,
      parentScenario,
    });
  }

  getLogMethods(): string[] {
    return ['ajax'];
  }
}
